import React from 'react';

import Image from '../../../../library/image/image';
import SnowyRoad from '../../../snowy-road/snowy-road';

import styles from './snow-acceleration-chart.scss';

interface SnowAccelerationChartProps {
  bottomOffset?: number;
  value: number;
}

function SnowAccelerationChart(props: SnowAccelerationChartProps) {
  const { bottomOffset = 0, value } = props;

  return (
    <div className={styles['container']}>
      <span className={styles['value']} style={{ bottom: bottomOffset + 21 }}>
        {value?.toFixed(1)} Sec
      </span>
      <span className={styles['label']} style={{ bottom: bottomOffset + 27 }}>
        30mph
      </span>
      <div className={styles['empty']} style={{ bottom: bottomOffset + 8 }} />
      <div className={styles['fill']} style={{ bottom: bottomOffset + 8 }} />
      <Image
        alt="Car Image"
        className={styles['car-image']}
        src="https://discounttire.scene7.com/is/image/discounttire/ic_car?fmt=png-alpha"
        style={{ bottom: bottomOffset + 6 }}
      />

      <SnowyRoad />
    </div>
  );
}

export default SnowAccelerationChart;
